export type Language = "zh" | "en";

const zh = {
  appName: "ClusterCA Web V2",
  run: "运行",
  pause: "暂停",
  step: "单步",
  undo: "撤销",
  redo: "重做",
  saveProject: "保存项目",
  newProject: "新建项目",
  loadProject: "载入项目",
  restoreAutosave: "恢复存档",
  settings: "设置",
  tickRate: "速率",
  tick: "Tick",
  tools: "工具",
  select: "选择",
  pan: "平移",
  cluster: "胞团",
  organelle: "器官",
  material: "物质",
  organelleType: "器官类型",
  direction: "作用方向",
  up: "上",
  right: "右",
  down: "下",
  left: "左",
  layers: "图层",
  layerCluster: "团簇层",
  layerMaterial: "物质层",
  layerLight: "光层",
  inspector: "对象检查器",
  inspectorHint: "使用“选择”工具点击胞团，查看其精确运行态。",
  currentSnapshot: "当前快照",
  clusterCount: "胞团数",
  seedCount: "休眠种子",
  materialCells: "非空物质格",
  simState: "模拟状态",
  running: "运行中",
  paused: "已暂停",
  export: "导出",
  metricsCsv: "指标 CSV",
  selectionJson: "选区三层 JSON",
  viewPng: "当前视图 PNG",
  trustWarning: "脚本尚未运行",
  trustEnable: "信任并启用",
  eventLog: "事件日志",
  ready: "就绪",
  worldInit: "世界已初始化：2048×2048 / 32×32 区块",
  error: "错误",
  newWorldTitle: "选择新建模板",
  newWorldDesc: "模板只作用于新世界，不会覆盖已载入项目。运行期规则不使用随机数，种子只决定初始环境。",
  projectSeed: "项目种子",
  templateBlank: "空白",
  templateBlankDesc: "只建立 2048×2048 三层环面，适合从零搭建。",
  templateEcology: "标准生态",
  templateEcologyDesc: "按种子放置物质、能量与 8 个初始藻类。",
  templateCustom: "定制",
  templateCustomDesc: "空白世界并打开自定义器官与声明式规则编辑器。",
  customEditor: "自定义器官",
  customEditorHint: "编辑器只接受器官定义与确定性条件/动作规则，不执行脚本。代码范围为 0100–FFEF。",
  customApply: "验证并加入调色板",
  customMissingParts: "JSON 必须同时包含 definition 和 rule",
  customBadCode: "器官代码不是有效十六进制或整数",
  customSubmitted: "已提交自定义器官 {code}，等待 Worker 验证",
  customInvalid: "自定义器官 JSON 无效：{message}",
  templateDeveloper: "开发者",
  templateDeveloperDesc: "空白世界 + 预置光合、推进、数字信号示例胞团，便于调试规则。",
  templateTour: "新手引导",
  templateTourDesc: "走一遍基础操作教程，结束后自动返回模板界面。",
  tourCanvasTitle: "画布",
  tourCanvasBody: "中键拖动平移视野；滚轮缩放；左键放置或选中；Ctrl+左键擦除；双击查看属性；按空格快速回到原点。",
  tourRunTitle: "运行控制",
  tourRunBody: "「运行/暂停/单步」控制模拟进度，拖动滑块调节 Tick 速率，右侧显示当前 Tick。",
  tourToolsTitle: "工具",
  tourToolsBody: "选择、平移、胞团、器官、物质、遗传。先点选工具，再在画布上操作。",
  tourBrushTitle: "放置 / 擦除",
  tourBrushBody: "切换放置或擦除模式；擦除模式下点击、或按住 Ctrl 点击画布，即可删除对象与物质。",
  tourLayersTitle: "图层",
  tourLayersBody: "团簇层、物质层、光层可独立显示或隐藏，合成视图便于观察三层数据。",
  tourGridTitle: "网格开关",
  tourGridBody: "打开或关闭画布上的网格参考线（鲜红单格线 + 灰色区块线）。",
  tourGenesTitle: "遗传模板",
  tourGenesBody: "粘贴或导入基因成为团簇模板；选中模板后使用「遗传」工具在画布上放置种子，种子会按基因发育。",
  tourSettingsTitle: "设置",
  tourSettingsBody: "背景颜色、亮度、字体大小、语言、自动保存间隔与导出路径都在这里调整。",
  tourInspectorTitle: "属性栏",
  tourInspectorBody: "选中胞团后查看状态、编辑备注、导出基因；未选中时显示全局运行统计。",
  tourDoneTitle: "开始搭建",
  tourDoneBody: "引导结束。点击「完成」返回模板界面，或继续编辑当前世界。",
  tourNoMore: "不再显示",
  tourRestart: "重看引导",
  aboutTitle: "关于我们",
  aboutVersion: "开发版本：{version}",
  aboutAuthor: "作者：Anshonesoo (安山苏)",
  aboutStage: "目前处于开发初期阶段，稳定性较差，请谅解。",
  aboutContact: "如有难以解决的 bug 可以联系作者，作者大概率会尝试修改。",
  aboutContactNote: "咨询请备注原因",
  aboutClose: "关闭",
  templates: "模板",
  teaching: "教学",
  teachingHint: "点击左侧卡片聚焦到对应器官演示；运行教学地图可观察每个器官的行为。",
  notOpen: "未开放",
  notOpenHint: "该模板尚未开放，敬请期待。",
  tourStep1Title: "欢迎",
  tourStep1Body: "这是 2048×2048 的环面世界。中键拖动可平移视野，滚轮缩放，按空格快速回到原点。",
  tourStep2Title: "放置",
  tourStep2Body: "左键点击空白处按当前工具放置；点中对象则选中；按住左键拖拽可批量放置。",
  tourStep3Title: "擦除",
  tourStep3Body: "按住 Ctrl 加左键点击，或切换到左侧「擦除」滑块，即可擦除对象与物质。",
  tourStep4Title: "编辑与查看",
  tourStep4Body: "左侧选择工具、器官与图层；双击胞团可在右侧属性栏查看详细信息。",
  tourStep5Title: "运行与导出",
  tourStep5Body: "顶部运行/暂停/单步控制模拟，右侧可导出指标 CSV、选区 JSON 与截图 PNG。",
  tourNext: "下一步",
  tourBack: "上一步",
  tourSkip: "跳过",
  tourFinish: "完成引导",
  note: "备注",
  health: "健康值",
  statusEnergetic: "精力充沛",
  statusNormal: "一般",
  statusDormant: "休眠",
  statusNecrotic: "坏死",
  organelleInfo: "器官信息",
  localCoord: "局部坐标",
  gene: "基因",
  geneTemplates: "遗传模板",
  genePaste: "在此粘贴基因（十六进制）",
  geneImportPaste: "导入粘贴",
  geneImportFile: "导入文件",
  geneExport: "导出基因",
  geneBad: "基因格式无效",
  geneNeed: "请先导入或选择遗传模板",
  geneExported: "基因已导出",
  genePrefix: "基因",
  randomSeed: "随机",
  cancel: "取消，返回当前项目",
  editCluster: "编辑：尝试在 ({x}, {y}) 创建 5×5 胞团",
  needSelect: "请先用选择工具选中一个胞团",
  autosaved: "自动存档完成：Tick {tick}",
  autosaveFailed: "自动存档失败：{message}",
  exported: "已导出 {file}",
  noAutosave: "没有可恢复的自动存档",
  loading: "正在载入 {file}",
  untrustedScripts: "项目包含 {count} 个未信任脚本，当前保持禁用",
  scriptsEnabled: "已启用可信脚本：{ids}",
  settingsTitle: "设置",
  settingsClose: "关闭",
  settingsBackground: "背景颜色",
  settingsBrightness: "亮度",
  settingsFontScale: "字体大小",
  settingsLanguage: "语言",
  settingsAutosave: "自动保存间隔",
  settingsExportMode: "导出路径",
  settingsExportDownload: "自动下载",
  settingsExportDirectory: "选择目录",
  settingsExportUnsupported: "当前浏览器不支持选择导出目录，已回退为自动下载。",
  settingsExportChosen: "已选择导出目录。",
  grid: "网格",
  place: "放置",
  erase: "擦除",
  collapseLeft: "折叠左侧栏",
  expandLeft: "展开左侧栏",
  collapseRight: "折叠右侧栏",
  expandRight: "展开右侧栏",
  languageZh: "中文",
  languageEn: "English",
  versionBy: "v0.2.0 · Anshonesoo",
};

const en: Record<keyof typeof zh, string> = {
  appName: "ClusterCA Web V2",
  run: "Run",
  pause: "Pause",
  step: "Step",
  undo: "Undo",
  redo: "Redo",
  saveProject: "Save Project",
  newProject: "New Project",
  loadProject: "Load Project",
  restoreAutosave: "Restore Autosave",
  settings: "Settings",
  tickRate: "Rate",
  tick: "Tick",
  tools: "Tools",
  select: "Select",
  pan: "Pan",
  cluster: "Cluster",
  organelle: "Organelle",
  material: "Material",
  organelleType: "Organelle",
  direction: "Direction",
  up: "Up",
  right: "Right",
  down: "Down",
  left: "Left",
  layers: "Layers",
  layerCluster: "Cluster Layer",
  layerMaterial: "Material Layer",
  layerLight: "Light Layer",
  inspector: "Inspector",
  inspectorHint: "Use the Select tool to click a cluster and inspect its exact runtime state.",
  currentSnapshot: "Current Snapshot",
  clusterCount: "Clusters",
  seedCount: "Seeds",
  materialCells: "Material Cells",
  simState: "Simulation",
  running: "Running",
  paused: "Paused",
  export: "Export",
  metricsCsv: "Metrics CSV",
  selectionJson: "Selection JSON",
  viewPng: "View PNG",
  trustWarning: "Scripts not running",
  trustEnable: "Trust & Enable",
  eventLog: "Event Log",
  ready: "Ready",
  worldInit: "World initialized: 2048×2048 / 32×32 chunks",
  error: "Error",
  newWorldTitle: "Choose a New World Template",
  newWorldDesc: "Templates only apply to a new world and never overwrite the loaded project. Runtime rules use no randomness; the seed only defines the initial environment.",
  projectSeed: "Project Seed",
  templateBlank: "Blank",
  templateBlankDesc: "Creates an empty 2048×2048 three-layer torus. Best for building from scratch.",
  templateEcology: "Ecology",
  templateEcologyDesc: "Places material, energy and 8 initial algae from the seed.",
  templateCustom: "Custom",
  templateCustomDesc: "Blank world with the custom organelle and declarative rule editor open.",
  customEditor: "Custom Organelle",
  customEditorHint: "Accepts organelle definitions and deterministic condition/action rules only; scripts are not executed. Code range: 0100–FFEF.",
  customApply: "Validate & Add to Palette",
  customMissingParts: "JSON must contain both definition and rule",
  customBadCode: "Organelle code is not a valid hexadecimal or integer value",
  customSubmitted: "Submitted custom organelle {code} for Worker validation",
  customInvalid: "Invalid custom organelle JSON: {message}",
  templateDeveloper: "Developer",
  templateDeveloperDesc: "Blank world with sample clusters for photosynthesis, thrust and digital signals, handy for rule debugging.",
  templateTour: "New User Guide",
  templateTourDesc: "Walk through the basic controls; returns to the template screen when finished.",
  tourCanvasTitle: "Canvas",
  tourCanvasBody: "Drag with the middle button to pan, scroll to zoom; left-click to place or select; Ctrl+left-click to erase; double-click to inspect; press Space to return to the origin.",
  tourRunTitle: "Run Controls",
  tourRunBody: "Use Run/Pause/Step to drive the simulation and drag the slider to set the tick rate. Current tick is shown on the right.",
  tourToolsTitle: "Tools",
  tourToolsBody: "Select, Pan, Cluster, Organelle, Material, Gene. Pick a tool first, then act on the canvas.",
  tourBrushTitle: "Place / Erase",
  tourBrushBody: "Switch between place and erase modes. In erase mode (or holding Ctrl) clicking removes objects and material.",
  tourLayersTitle: "Layers",
  tourLayersBody: "Cluster, material and light layers can be toggled independently to inspect the three-layer data.",
  tourGridTitle: "Grid Toggle",
  tourGridBody: "Show or hide the canvas grid reference lines (red cell lines + gray chunk lines).",
  tourGenesTitle: "Gene Templates",
  tourGenesBody: "Paste or import a gene to create a cluster template; select it, then use the Gene tool to place a seed that develops per the gene.",
  tourSettingsTitle: "Settings",
  tourSettingsBody: "Adjust background, brightness, font size, language, autosave interval and export path here.",
  tourInspectorTitle: "Inspector",
  tourInspectorBody: "Inspect the selected cluster, edit its note and export its gene; otherwise it shows global run statistics.",
  tourDoneTitle: "Start Building",
  tourDoneBody: "The guide is finished. Click Finish to return to the template screen, or keep editing the current world.",
  tourNoMore: "Don't show again",
  tourRestart: "Restart guide",
  aboutTitle: "About Us",
  aboutVersion: "Dev version: {version}",
  aboutAuthor: "Author: Anshonesoo",
  aboutStage: "This is an early development stage. Stability may be limited; please bear with us.",
  aboutContact: "If you run into a bug you cannot solve, contact the author; they will likely try to fix it.",
  aboutContactNote: "Please state your reason when contacting",
  aboutClose: "Close",
  templates: "Templates",
  teaching: "Teach",
  teachingHint: "Click a card to focus its organ demo; run the teaching map to observe each organ's behavior.",
  notOpen: "Not available",
  notOpenHint: "This template is not available yet.",
  tourStep1Title: "Welcome",
  tourStep1Body: "This is a 2048×2048 torus world. Drag with the middle mouse button to pan, scroll to zoom, press Space to return to the origin.",
  tourStep2Title: "Place",
  tourStep2Body: "Left-click empty space to place with the current tool; click an object to select it; drag to place in bulk.",
  tourStep3Title: "Erase",
  tourStep3Body: "Hold Ctrl and left-click, or switch to the Erase mode slider on the left, to remove objects and material.",
  tourStep4Title: "Edit & Inspect",
  tourStep4Body: "Pick tools, organelles and layers on the left; double-click a cluster to inspect its details in the right panel.",
  tourStep5Title: "Run & Export",
  tourStep5Body: "Use Run/Pause/Step on top, and export metrics CSV, selection JSON or PNG screenshot from the right panel.",
  tourNext: "Next",
  tourBack: "Back",
  tourSkip: "Skip",
  tourFinish: "Finish",
  note: "Note",
  health: "Health",
  statusEnergetic: "Energetic",
  statusNormal: "Normal",
  statusDormant: "Dormant",
  statusNecrotic: "Necrotic",
  organelleInfo: "Organelle Info",
  localCoord: "Local Position",
  gene: "Gene",
  geneTemplates: "Gene Templates",
  genePaste: "Paste gene (hexadecimal)",
  geneImportPaste: "Import pasted",
  geneImportFile: "Import file",
  geneExport: "Export gene",
  geneBad: "Invalid gene format",
  geneNeed: "Import or select a gene template first",
  geneExported: "Gene exported",
  genePrefix: "Gene",
  randomSeed: "Random",
  cancel: "Cancel, back to current project",
  editCluster: "Edit: trying to create 5×5 cluster at ({x}, {y})",
  needSelect: "Select a cluster with the Select tool first",
  autosaved: "Autosave complete: Tick {tick}",
  autosaveFailed: "Autosave failed: {message}",
  exported: "Exported {file}",
  noAutosave: "No autosave available",
  loading: "Loading {file}",
  untrustedScripts: "Project contains {count} untrusted scripts; they stay disabled",
  scriptsEnabled: "Enabled trusted scripts: {ids}",
  settingsTitle: "Settings",
  settingsClose: "Close",
  settingsBackground: "Background",
  settingsBrightness: "Brightness",
  settingsFontScale: "Font Size",
  settingsLanguage: "Language",
  settingsAutosave: "Autosave Interval",
  settingsExportMode: "Export Path",
  settingsExportDownload: "Auto download",
  settingsExportDirectory: "Choose directory",
  settingsExportUnsupported: "This browser does not support choosing an export directory; falling back to download.",
  settingsExportChosen: "Export directory chosen.",
  grid: "Grid",
  place: "Place",
  erase: "Erase",
  collapseLeft: "Collapse left panel",
  expandLeft: "Expand left panel",
  collapseRight: "Collapse right panel",
  expandRight: "Expand right panel",
  languageZh: "中文",
  languageEn: "English",
  versionBy: "v0.2.0 · Anshonesoo",
};

export type TranslationKey = keyof typeof zh;

const dictionaries: Record<Language, Record<TranslationKey, string>> = { zh, en };

export const translate = (language: Language): ((key: TranslationKey) => string) => {
  const dict = dictionaries[language];
  return (key: TranslationKey): string => dict[key] ?? zh[key] ?? String(key);
};

export const formatText = (template: string, values: Record<string, string | number>): string => {
  let result = template;
  for (const [key, value] of Object.entries(values)) result = result.replaceAll(`{${key}}`, String(value));
  return result;
};
